<div class="flex flex-col gap-5">
  <h5 [@first] class="text-zen font-medium text-3xl">
    {{ "txt_notification_settings" | translate: language:ModuleNames.Common }}
  </h5>

  <div class="my-8 py-5">
    <!-- Row 1: Remaining Units & Subscription Expiring -->
    <div class="flex flex-row gap-4 w-full exp">
      <!-- Remaining Units Toggle -->
      <div class="flex flex-row md:w-1/2 w-full justify-between items-center bg-white rounded py-3 px-4 mb-4">
        <h5 [@child8] class="m-0">
          {{ "txt_notification_remaining_units" | translate: language:ModuleNames.Common }}
        </h5>
        <z-toggle 
          [@child10] 
          [(ngModel)]="user.remainingUnits"
          (ngModelChange)="onNotificationChange()">
        </z-toggle>
      </div>

      <!-- Subscription Expiring Toggle -->
      <div class="flex flex-row md:w-1/2 w-full justify-between items-center bg-white rounded py-3 px-4 mb-4">
        <h5 [@child10] class="m-0">
          {{ "txt_notification_subscription_expiring" | translate: language:ModuleNames.Common }}
        </h5>
        <z-toggle 
          [@child12] 
          [(ngModel)]="user.subscriptionExpiring"
          (ngModelChange)="onNotificationChange()">
        </z-toggle>
      </div>
    </div>

    <!-- Row 2: Subscription Expired -->
    <div class="flex flex-row gap-4 w-full exp">
      <!-- Subscription Expired Toggle -->
      <div class="flex flex-row md:w-1/2 w-full justify-between items-center bg-white rounded py-3 px-4 mb-4">
        <h5 [@child10] class="m-0">
          {{ "txt_notification_subscription_expired" | translate: language:ModuleNames.Common }}
        </h5>
        <z-toggle 
          [@child12] 
          [(ngModel)]="user.subscriptionExpired"
          (ngModelChange)="onNotificationChange()">
        </z-toggle>
      </div>
      
      <!-- Spacer for alignment -->
      <span class="w-1/2"></span>
    </div>
  </div>
</div>
